import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "pt-20"
};
const _hoisted_2 = { class: "flex justify-center px-8 mt-16 space-x-8 lg:space-x-32 xl:space-x-48" };
const _hoisted_3 = { class: "flex flex-col items-center w-81" };
const _hoisted_4 = { class: "flex items-center w-full mt-12 space-x-2" };
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("hr", { class: "w-full border-gray-300 dark:border-gray-500" }, null, -1);
const _hoisted_6 = { class: "flex-1 text-gray-300 dark:text-gray-500 whitespace-nowrap" };
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("hr", { class: "w-full border-gray-300 dark:border-gray-500" }, null, -1);
const _hoisted_8 = { class: "mt-8 text-xs text-gray-500" };
import componentI18n from '@/i18n/componentI18n';
const __default__ = {
    ...componentI18n('views.workspaces.index')
};
import { computed, onMounted, ref } from 'vue';
import { useStore } from 'vuex';
import { getWorkspaces } from '@/data/workspaces';
import Selector from '@/components/workspaces/Selector.vue';
import WorkspaceImage from '@/components/workspaces/WorkspaceImage.vue';
export default /*#__PURE__*/ _defineComponent({
    ...__default__,
    __name: 'Index',
    setup(__props) {
        const store = useStore();
        const workspaces = ref(null);
        const logout = () => store.dispatch('logout', 'login');
        const sortedWorkspaces = computed(() => {
            const result = workspaces.value?.slice().sort((w1, w2) => {
                const t1 = new Date(w1.lastVisitedAt).getTime();
                const t2 = new Date(w2.lastVisitedAt).getTime();
                return t2 - t1;
            });
            return result || [];
        });
        onMounted(async () => {
            try {
                workspaces.value = await getWorkspaces();
            }
            catch (e) {
                store.dispatch('flashThenClear', { message: 'error_loading_workspaces' });
            }
        });
        return (_ctx, _cache) => {
            const _component_section_heading = _resolveComponent("section-heading");
            const _component_pill_button = _resolveComponent("pill-button");
            const _component_router_link = _resolveComponent("router-link");
            return (workspaces.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createVNode(_component_section_heading, {
                        heading: _ctx.$t('heading'),
                        subheading: _ctx.$t('subheading')
                    }, null, 8, ["heading", "subheading"]),
                    _createElementVNode("div", _hoisted_2, [
                        _createVNode(WorkspaceImage, { class: "hidden md:block" }),
                        _createElementVNode("div", _hoisted_3, [
                            _createVNode(_component_router_link, {
                                to: { name: 'createWorkspace' },
                                class: "w-full"
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_pill_button, {
                                        size: "xl",
                                        class: "h-16"
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t('create_workspace')), 1)
                                        ], undefined, true),
                                        _: 1
                                    })
                                ], undefined, true),
                                _: 1
                            }),
                            _createElementVNode("div", _hoisted_4, [
                                _hoisted_5,
                                _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('or_open')), 1),
                                _hoisted_7
                            ]),
                            _createVNode(Selector, {
                                class: "mt-8 w-81 max-h-45",
                                workspaces: _unref(sortedWorkspaces)
                            }, null, 8, ["workspaces"]),
                            _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t('different_workspace')), 1),
                            _createVNode(_component_pill_button, {
                                class: "mt-2",
                                kind: "secondary",
                                onClick: logout
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('different_email')), 1)
                                ], undefined, true),
                                _: 1
                            })
                        ])
                    ])
                ]))
                : _createCommentVNode("", true);
        };
    }
});
